import { FC } from "react";
import clsx from "classnames";
import { useStyles } from "./NotchMenu.style";
import { Icon, Image } from "@onmo/ui";
import Button from "../../core/Button/Button";
import { NativeShare } from "../../../models/nativeShare";
import { PageRoutes } from "../../../constants/historyGaming";
import { useTranslation } from "react-i18next";
import { assetsImages } from "../../../models/theme";

interface IArrowCollapseProps {
  onClose?: () => void;
  onAction?: () => void;
  open?: boolean;
  feedId: string;
}

export const NotchMenu: FC<IArrowCollapseProps> = (props) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { onClose, onAction, open, feedId } = props;
  const onShare = (serviceDataId?: string) => {
    NativeShare.share({
      url: `${window.location.origin}${PageRoutes.Apps}/${serviceDataId}`,
    });
  };

  return (
    <div className={clsx(classes.menu, { open })} id="notch-menu">
      <div className={classes.menuHeader}>
        <Image src={assetsImages.notchLogo} height={40} />
        <div className={classes.menuHeaderRight}>
          {/* <Icon name="icon-bold-heart" className={classes.icon} /> */}
          <Icon
            name="icon-bold-share"
            className={classes.icon}
            onClick={() => onShare(feedId)}
          />
        </div>
      </div>
      <div className={classes.menuFooter}>
        <Button fullWidth onClick={onAction} className={classes.button}>
          {t("common_Return Home")}
        </Button>
        <Button
          variant="outlined"
          fullWidth
          onClick={onClose}
          className={classes.button}
        >
          {t("common_Close")}
        </Button>
      </div>
    </div>
  );
};
